import styled from 'styled-components';

export const DesktopMenuWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 25px;
  padding-left: 100px;
  padding-right: 100px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.width1550}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    width: 80%;
    margin: auto;
  }
`;

export const LogoImage = styled.img<{ $height?: string; $maxWidth?: string }>`
  height: ${({ $height }) => $height};
  max-width: ${({ $maxWidth }) => $maxWidth ?? 'auto'};
  object-fit: contain;
  cursor: pointer;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 42px;
  margin-top: -5px;
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
